module.exports = __webpack_public_path__ + "img/success.8c1ba6b8.png";